import React from 'react';

import { useStyles } from '~/assets/styles';
import ClaimNotificationsContainer from '~/components/ClaimNotificationsContainer';
import { PERMISSION_ACTIONS, PERMISSION_VERBS, PermissionsRenderWrapper } from '~/components/core';

interface ClaimNotificationsTabProps {
  classes?: Record<string, string>;
  isTabActive?: boolean;
}

/**
 * Notifications Tab Component for CliveClaimPage
 * Displays claim notifications with proper permissions wrapper
 */
const ClaimNotificationsTab: React.FC<ClaimNotificationsTabProps> = ({ isTabActive: _isTabActive = true }) => {
  const { classes } = useStyles();

  return (
    <PermissionsRenderWrapper action={PERMISSION_ACTIONS.NOTIFICATION} verb={PERMISSION_VERBS.READ}>
      <div className={classes.cardDivRow}>
        <ClaimNotificationsContainer />
      </div>
    </PermissionsRenderWrapper>
  );
};

export default ClaimNotificationsTab;
